const crypto = require('crypto')

module.exports = {
  encrypt (valueToEncrypt, publicKey) {
    const buffer = Buffer.from(valueToEncrypt, 'utf8')
    const encrypted = crypto.publicEncrypt(publicKey, buffer)
    return encrypted.toString('base64')
  },
  decrypt (valueToDecrypt, privateKey) {
    const buffer = Buffer.from(valueToDecrypt, 'base64')
    const decrypted = crypto.privateDecrypt(privateKey, buffer)
    return decrypted.toString('utf8')
  }
}
